module.exports = __webpack_public_path__ + "static/Moonlighter0-a1a04833b195407d1e2b8caa78f82200.png";